import { useState, useEffect } from "react";
import { TrashIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import { toJalali } from "../../utils/moment";
import { deleteLesson } from "../../api/lesson";
import GetAdmin from "../../utils/getAdmin";

const LessonTable = ({
  data,
  setStatus,
  setShowNotification,
  setRefresh,
  setLessonId,
  setEdit,
  adminRole,
}) => {
  const [showDeleteAcception, setShowDeleteAcception] = useState();
  const [deleteLessonId, setDeleteLessonId] = useState();

  const handleDeleteLesson = async () => {
    try {
      const res = await deleteLesson(deleteLessonId);
      setShowNotification(true);
      setStatus(res.status);
      setRefresh((prev) => !prev);
      setShowDeleteAcception(false);
    } catch (err) {
      setShowNotification(true);
      setStatus(502);
      setShowDeleteAcception(false);
    }
  };

  const handleEditLesson = async (id) => {
    setEdit(true);
    setLessonId(id);
  };

  const getBookName = (bookNumber) => {
    switch (bookNumber) {
      case "1":
        return "ریاضی";
      case "2":
        return "فارسی";
      case "3":
        return "علوم";
      case "4":
        return "قرآن";
      case "5":
        return "نگارش";
      case "6":
        return "هدیه";
      case "7":
        return "مطالعات";
      default:
        return "نامشخص";
    }
  };

  return (
    <div className="w-full mx-auto bg-white rounded-lg shadow-lg p-2 sm:p-4 md:p-6">
      {/* تاییدیه حذف  */}
      {showDeleteAcception ? (
        <div className="fixed inset-0 z-50 flex items-center justify-center  bg-opacity-40">
          <div className="w-full max-w-md bg-white shadow-2xl rounded-xl p-6">
            <div className="text-center mb-6">
              <h2 className="text-xl font-bold text-red-600 mb-2">هشدار</h2>
              <p className="text-gray-700 text-sm">
                با این کار تمام سوالات مربوط به این درس بی‌تکلیف می‌مانند. آیا
                از حذف اطمینان دارید؟
              </p>
            </div>

            <div className="flex justify-between">
              <button
                className="bg-red-300 hover:bg-red-800 transition text-white px-4 py-2 rounded-lg w-full mx-1"
                onClick={handleDeleteLesson}
              >
                تایید
              </button>
              <button
                className="bg-gray-300 hover:bg-gray-400 transition text-gray-800 px-4 py-2 rounded-lg w-full mx-1"
                onClick={() => {
                  setShowDeleteAcception(false);
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      ) : null}

      {/* عنوان و جستجو */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-4 md:mb-6">
        <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-[#075B4A] mb-4 md:mb-0">
          مدیریت درس ها
        </h1>
      </div>

      {/* جدول */}
      <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
        <table className="w-full text-right text-xs sm:text-sm">
          <thead className="bg-gray-50">
            <tr>
              {[
                "نام درس",
                "پایه",
                "کتاب",
                "فصل",
                "شماره درس",
                "تاریخ",
                "نویسنده",

                "ویرایش",
                "حذف",
              ].map((header) => (
                <th
                  key={header}
                  className="px-2 py-2 sm:px-4 sm:py-3 font-medium text-gray-700"
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {data.map((item, index) => (
              <tr
                key={index}
                className="bg-white hover:bg-gray-50 transition-colors"
              >
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {item.title}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {item.grade}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {getBookName(item.book)}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {item.season}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {item.lesson}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {toJalali(item.created_at)}
                </td>
                <td className="px-2 py-2 sm:px-4 sm:py-3 whitespace-nowrap">
                  {item.creatorName}
                </td>
                {adminRole === "manager" ? (
                  <td className="px-2 py-2 sm:px-4 sm:py-3">
                    <button
                      className="p-1 sm:p-1.5 hover:bg-blue-100 rounded-full transition-colors"
                      onClick={() => handleEditLesson(item._id)}
                    >
                      <PencilSquareIcon className="h-4 w-4 sm:h-5 sm:w-5 text-blue-600" />
                    </button>
                  </td>
                ) : null}
                {adminRole === "manager" ? (
                  <td className="px-2 py-2 sm:px-4 sm:py-3">
                    <button
                      onClick={() => {
                        setDeleteLessonId(item._id);
                        setShowDeleteAcception(true);
                      }}
                      className="p-1 sm:p-1.5 hover:bg-red-100 rounded-full transition-colors"
                    >
                      <TrashIcon className="h-4 w-4 sm:h-5 sm:w-5 text-red-600" />
                    </button>
                  </td>
                ) : null}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LessonTable;
